import { Injectable } from "@angular/core";
import { AppConfig, UvExplorerClient } from "common";
import { Observable, Subject } from "rxjs";
import { TopoImageEntry } from "topomap/topology/TopoImageEntry";

@Injectable()
export class TopoMapConfigurationWebService {
    
    constructor(private appConfig: AppConfig, private uvExplorerClient: UvExplorerClient) {
        return;
    }

    public getUserTopoImageMap(): Observable<TopoImageEntry[]> {
		let url = this.appConfig.webServerUrl + `config/userimages`;
		let subject = new Subject<TopoImageEntry[]>();

		this.uvExplorerClient.get<TopoImageEntry[]>(url).subscribe(
			(result: TopoImageEntry[]) => {
				subject.next(result);
			},
			(error) => {
				console.error(error);
				subject.error(error);
			});

		return subject.asObservable();
	}

	public getTopoImageEntries(): Observable<TopoImageEntry[]> {
		let url = this.appConfig.webServerUrl + `config/mapimages`;
		let subject = new Subject<TopoImageEntry[]>();

		this.uvExplorerClient.get<TopoImageEntry[]>(url).subscribe(
			(result: TopoImageEntry[]) => {
				subject.next(result);
			},
			(error) => {
				console.error(error);
				subject.error(error);
			});

		return subject.asObservable();
	}
}